import { AxiosRequestConfig } from 'axios'

export interface RateMetricData {
  title: string
  value: number
  comparisonValue?: number
  diff?: number
  isPositive?: boolean
}

export interface RateMetricsResponse {
  data: RateMetricData[]
}

export interface RateMetricsParams {
  endDate: string
  storeId?: number
  comparisonStoreId?: number
}

const getRateMetrics = (params: RateMetricsParams): AxiosRequestConfig => ({
  url: '/dashboard/rate-metrics',
  method: 'GET',
  params,
})

export { getRateMetrics }
